import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Result, mappingResultError } from '@digibricks/core';
import { SECURITY_OPTION_REPOSITORY } from '../../core';
import { SECURITY_OPTION_API } from '../data-sources';
import { SecurityOptionMapper } from './security-option.mapper';
export var SecurityOptionRepository = /*#__PURE__*/function () {
  function SecurityOptionRepository(securityOptionApi, securityOptionMapper) {
    _classCallCheck(this, SecurityOptionRepository);

    this.securityOptionApi = securityOptionApi;
    this.securityOptionMapper = securityOptionMapper;

    _defineProperty(this, "cachedSecurityOptions", []);
  }

  _createClass(SecurityOptionRepository, [{
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var responseOrError, responseDto, results, _iterator, _step, dto, securityOptionsOrError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.cachedSecurityOptions.length > 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", Result.ok(this.cachedSecurityOptions));

              case 2:
                _context.next = 4;
                return this.securityOptionApi.getSecurityOptions();

              case 4:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 7:
                responseDto = responseOrError.getValue();
                results = [];
                _iterator = _createForOfIteratorHelper(responseDto);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    dto = _step.value;
                    results.push(this.securityOptionMapper.toDomain(dto));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                securityOptionsOrError = Result.combineArray(results);

                if (!securityOptionsOrError.isFailure) {
                  _context.next = 14;
                  break;
                }

                return _context.abrupt("return", Result.fail(securityOptionsOrError.error));

              case 14:
                this.cachedSecurityOptions = securityOptionsOrError.getValue();
                return _context.abrupt("return", securityOptionsOrError);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMany() {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
  }]);

  return SecurityOptionRepository;
}();
export var securityOptionRepositoryProvider = {
  provide: SECURITY_OPTION_REPOSITORY,
  useFactory: function useFactory(securityOptionApi, mapper) {
    return new SecurityOptionRepository(securityOptionApi, mapper);
  },
  inject: [SECURITY_OPTION_API, SecurityOptionMapper]
};